import React from "react";
import PropTypes from "prop-types";
import Person from "./Person";
import { sequence } from "@totalsoft/react-state-lens";

function PersonList({
  partnerLens,
  isSoleTraderFeature,
  genderValues,
  countries,
  counties,
  onRemove,
  onBack,
  validation,
}) {
  return (partnerLens.persons |> sequence).map((personLens, index) => (
    <Person
      key={index}
      index={index + 1}
      personLens={personLens}
      isSoleTraderFeature={isSoleTraderFeature}
      genderValues={genderValues}
      countries={countries}
      counties={counties}
      onRemove={onRemove}
      onBack={onBack}
      validation={validation[index]}
    />
  ));
}

PersonList.propTypes = {
  partnerLens: PropTypes.object.isRequired,
  isSoleTraderFeature: PropTypes.bool.isRequired,
  genderValues: PropTypes.array.isRequired,
  countries: PropTypes.array.isRequired,
  counties: PropTypes.array.isRequired,
  onRemove: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
};

export default PersonList;
